module.exports = __webpack_public_path__ + "static/gallery-11-a62d56555c3e7f36df53af60c1f2a33f.jpg";